import PanelContent from "./panelContent.js"

export default PanelContent
